import _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SharedService } from 'app/virtual-event/services/shared.service';

@Injectable({
  providedIn: 'root'
})
export class ChatService {

  constructor(
    private http: HttpClient,
    private sharedService: SharedService,
    private cookieService: CookieService
  ) { }

  sendChatMessage(id, message) {
    const token = this.cookieService.get('accessToken');
    return this.http.post('/api/vevent/sendMessage', `access_token=${token}&mode=admin&eventId=${id}&message=${message}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  deleteChatMessage(id, blockUser) {
    const token = this.cookieService.get('accessToken');
    const transformedData = JSON.stringify({ id, blockUser });
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(transformedData)}`
    ];
    return this.http.post('/api/vevent/deleteMessage', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  ublockChatAttendee(chatMessageId) {
    const token = this.cookieService.get('accessToken');
    const transformedData = JSON.stringify({ chatMessageId });
    const queryParams = [
      `access_token=${token}`,
      `p=${encodeURIComponent(transformedData)}`
    ];
    return this.http.post('/api/vevent/unblockAttendeeChat', _.join(queryParams, "&"), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }

  getVirtualEvent(id: number) {
    return this.http.post('/api/vevent/get', `id=${id}`, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
  }
}
